<template>
  <div class="loading-container" :class="showLoading ? 'show' : 'hide'">
    <div class="loading"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showLoading: false,
    };
  },
  methods: {
    show(time = 3000) {
      this.showLoading = true;
      // setTimeout(() => {
      //   this.hide();
      // }, time);
    },
    hide() {
      this.showLoading = false;
    },
  },
};
</script>

<style lang="scss">
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
  background: rgba(0, 22, 53, 0.3);
  background: rgba(0, 22, 53, 0.6);
  &.show {
    display: block;
  }
  &.hide {
    display: none;
  }
}
.loading {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border-radius: 100%;
  border: 5px #1c093a solid;
  border-right-color: #b508f1;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
